__turbopack_context__.v({
  "indicator": "Tabs-module-scss-module__PZadlW__indicator",
  "label": "Tabs-module-scss-module__PZadlW__label",
  "list": "Tabs-module-scss-module__PZadlW__list",
  "pill": "Tabs-module-scss-module__PZadlW__pill",
  "root": "Tabs-module-scss-module__PZadlW__root",
  "tab": "Tabs-module-scss-module__PZadlW__tab",
});
